/* Silberkraft – Berater-Button + Foto-Erkennung in der Header-Suche (Philipp 02.11.2026, Vorbild Bergzeit).
 * Markup: snippets/sk-live-search.liquid (Button [data-skfb-berater] im Formular, Boot-Stub sk-berater-boot).
 * - Button: mit Suchbegriff → KI-Chat (window.SkLiveChat.open, 03.11.2026); ohne Begriff/ohne Chat → KI-Berater (window.SkBerater.open, Engine wird bei Bedarf nachgeladen).
 * - Beim Fokus ins leere Suchfeld zeigt sk-live-search.js die „Beliebte Suchen“; davor hängen wir
 *   „Foto von Schädling oder Pflanze hochladen“ (+ „Kamera“ auf Touch-Geräten).
 * - Foto → POST <erp>/public/berater/photo (Bild wird dort nicht gespeichert) → Text + max. 3 lieferbare Produkte.
 * API für den Berater selbst: window.SkFotoBerater.pick(box). */
(function () {
  if (window.SkFotoBerater) return;
  var API = "https://erp-api-289183413262.europe-west1.run.app/public/berater/photo";
  var MAX = 1600;
  var T = {
    photo: "Foto von Schädling oder Pflanze hochladen",
    photoSub: "Wir erkennen die Art und schlagen passende Mittel vor.",
    cam: "Kamera", camLabel: "Foto mit der Kamera aufnehmen",
    busy: "Foto wird erkannt … das dauert etwa 10 Sekunden.",
    err: "Das hat nicht geklappt. Starte gern den Berater.",
    start: "Berater starten", plan: "Bekämpfungsplan im Berater erstellen", again: "Anderes Foto",
    privacy: "Dein Foto wird nur zur Erkennung genutzt und nicht gespeichert.",
    products: "Passende Mittel",
    empty: "Nichts gefunden? Unser Berater hilft – oder lade ein Foto hoch.", photoShort: "Foto hochladen"
  };
  var root = null, last = null, pending = null;

  function boot() { return document.querySelector("[data-skb-boot]"); }
  var engP = null;
  function engine() {
    if (window.SkBerater) return Promise.resolve();
    if (engP) return engP;
    var b = boot();
    if (!b) return Promise.reject(new Error("kein Berater-Boot"));
    engP = new Promise(function (ok, bad) {
      if (!document.querySelector("link[data-skb-css]")) {
        var l = document.createElement("link"); l.rel = "stylesheet"; l.href = b.getAttribute("data-skb-css"); l.setAttribute("data-skb-css", ""); document.head.appendChild(l);
      }
      var s = document.createElement("script"); s.type = "module"; s.src = b.getAttribute("data-skb-js");
      s.onload = function () { var n = 0; (function w() { if (window.SkBerater) return ok(); if (++n > 80) return bad(new Error("sk-berater.js")); setTimeout(w, 50); })(); };
      s.onerror = function () { bad(new Error("sk-berater.js")); };
      document.head.appendChild(s);
    }).catch(function (e) { engP = null; throw e; });
    return engP;
  }
  /* ERP-Quelle (View Upselling) + Sitzungs-ID der Foto-Erkennung weiterreichen → eine Sitzung statt zwei (03.11.2026) */
  var SOURCE = { "suche": "search_berater", "foto-suche": "search_photo" };
  function openBerater(group, via, btn, sid) {
    if (btn) btn.setAttribute("aria-busy", "true");
    return engine().then(function () {
      var o = { boot: boot(), group: group || null, entry: via, via: via };
      if (SOURCE[via]) o.source = SOURCE[via];
      if (sid) o.sid = String(sid);
      return window.SkBerater.open(o);
    }).catch(function (e) { if (window.console) console.error("[sk-foto-berater]", e); })
      .then(function () { if (btn) btn.removeAttribute("aria-busy"); });
  }

  /* Berater-Chat (Philipp 03.11.2026): Header-Button mit Suchbegriff → KI-Chat (SkLiveChat.open, Quelle search_chat).
     Ohne Suchbegriff oder ohne Chat (lädt erst nach der ersten Interaktion; max. 2,5 s warten) → geführter Berater. */
  function chatReady(ms) {
    function has() { return !!(window.SkLiveChat && typeof window.SkLiveChat.open === "function"); }
    if (has()) return Promise.resolve(true);
    return new Promise(function (ok) {
      var done = false; function fin() { if (!done) { done = true; ok(has()); } }
      document.addEventListener("sk-chat:ready", fin, { once: true });
      setTimeout(fin, ms);
    });
  }
  function headerBerater(btn) {
    var inp = root && root.querySelector("[data-sk-live-search-input], input[type=search], input[name=q]");
    var q = inp ? String(inp.value || "").trim() : "";
    if (q.length < 2) return openBerater(null, "suche", btn);
    btn.setAttribute("aria-busy", "true");
    return chatReady(2500).then(function (ok) {
      btn.removeAttribute("aria-busy");
      if (!ok) return openBerater(null, "suche", btn);
      var o = { prefill: q.slice(0, 500), source: "search" };
      var sid = beraterSid(); if (sid) o.sid = sid;
      try { if (inp) inp.blur(); } catch (_) {}
      window.SkLiveChat.open(o);
    });
  }

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function icon(path) { var s = document.createElementNS("http://www.w3.org/2000/svg", "svg"); s.setAttribute("viewBox", "0 0 24 24"); s.setAttribute("aria-hidden", "true"); s.setAttribute("focusable", "false"); s.innerHTML = path; return s; }
  var CAM = '<path d="M4 8h3l2-2.5h6L17 8h3v11H4z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="12" cy="13.5" r="3.5" fill="none" stroke="currentColor" stroke-width="1.8"/>';
  var IMG = '<rect x="3.5" y="4.5" width="17" height="15" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="9" cy="10" r="1.8" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="m4 18 5-5 4 4 3-3 4 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>';

  /* Datei-Inputs liegen IM Such-Root (sonst schließt der Outside-Click von sk-live-search.js das Dropdown). */
  var inputs = {};
  function fileInput(camera) {
    var k = camera ? "cam" : "file";
    if (inputs[k]) return inputs[k];
    var i = document.createElement("input");
    i.type = "file"; i.accept = "image/*"; i.hidden = true; i.tabIndex = -1; i.setAttribute("aria-hidden", "true");
    if (camera) i.setAttribute("capture", "environment");
    (root || document.body).appendChild(i);
    i.addEventListener("click", function (e) { e.stopPropagation(); });
    i.addEventListener("change", function () {
      var f = i.files && i.files[0]; i.value = "";
      if (f && i.__cb) i.__cb(f);
    });
    return (inputs[k] = i);
  }
  function pick(cb, camera) { var i = fileInput(camera); i.__cb = cb; i.click(); }

  function resize(file) {
    return new Promise(function (ok, bad) {
      var r = new FileReader();
      r.onerror = function () { bad(new Error("read")); };
      r.onload = function () {
        var img = new Image();
        img.onerror = function () { bad(new Error("img")); };
        img.onload = function () {
          var w = img.naturalWidth, h = img.naturalHeight, f = Math.min(1, MAX / Math.max(w, h));
          var c = document.createElement("canvas"); c.width = Math.round(w * f); c.height = Math.round(h * f);
          c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
          var q = 0.82, d = c.toDataURL("image/jpeg", q);
          while (d.length > 2700000 && q > 0.4) { q -= 0.12; d = c.toDataURL("image/jpeg", q); }
          ok(d);
        };
        img.src = r.result;
      };
      r.readAsDataURL(file);
    });
  }

  function beraterSid() { try { var s = window.SkBerater && window.SkBerater._state && window.SkBerater._state(); return s && s.sid ? String(s.sid) : null; } catch (_) { return null; } }
  function identify(file, source) {
    return resize(file).then(function (dataUrl) {
      var body = { image: dataUrl, source: source, pagePath: location.pathname.slice(0, 400), host: location.host };
      var sid = source === "berater" ? beraterSid() : null; if (sid) body.sid = sid; /* im Berater: dieselbe Sitzung weiterführen */
      return fetch(API, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || !j.data) throw new Error((j.error && j.error.message) || T.err);
          return { data: j.data, img: dataUrl };
        });
      });
    });
  }

  function money(c) { try { return new Intl.NumberFormat("de-DE", { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR" }).format(c / 100); } catch (_) { return (c / 100).toFixed(2).replace(".", ",") + " €"; } }
  function via(source) { return source === "berater" ? "foto-berater" : "foto-suche"; }
  function handleOf(p) { if (p.handle) return String(p.handle); var m = /\/products\/([^/?#]+)/.exec(p.url || ""); return m ? decodeURIComponent(m[1]) : ""; }
  /* Produkt-Klick im Foto-Ergebnis: zählen + Sitzung an den Warenkorb hängen (Umsatz-Zuordnung über _sk_berater_sid; 03.11.2026) */
  function productClick(p, sid) {
    var h = handleOf(p).slice(0, 120);
    try {
      if (window.SkBerater && window.SkBerater.track) window.SkBerater.track("click", { clickItem: h, h: h, sid: sid || null });
      else if (window.skTrack) window.skTrack({ k: "berater", e: "click", g: null, c: "suche", clickItem: h, h: h, sid: sid || null, src: "search_photo" });
    } catch (_) {}
    if (!sid) return;
    try {
      var rt = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      fetch(rt + "cart/update.js", { method: "POST", keepalive: true, headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ attributes: { _sk_berater_sid: String(sid) } }) }).catch(function () {});
    } catch (_) {}
  }

  /** Ergebnis in einen Container rendern (Suche + Berater nutzen dasselbe). */
  function render(box, res, source) {
    var d = res.data; box.textContent = "";
    var head = el("div", "skfb-res__head"), th = el("img", "skfb-res__thumb");
    th.src = res.img; th.alt = ""; th.width = 56; th.height = 56; head.appendChild(th);
    var tx = el("div");
    if (d.art) tx.appendChild(el("p", "skfb-res__name", d.art));
    tx.appendChild(el("p", "skfb-res__text", d.text)); head.appendChild(tx); box.appendChild(head);
    if (d.products && d.products.length) {
      box.appendChild(el("p", "skfb-res__h", T.products));
      var ul = el("ul", "skfb-res__list"); ul.setAttribute("role", "list");
      d.products.slice(0, 3).forEach(function (p) {
        var li = el("li"), a = el("a", "skfb-res__prod"); a.href = p.url;
        a.addEventListener("click", function () { productClick(p, d.sid); });
        if (p.image) { var im = el("img"); im.src = p.image + (p.image.indexOf("?") > -1 ? "&" : "?") + "width=120"; im.alt = ""; im.width = 48; im.height = 48; im.loading = "lazy"; a.appendChild(im); }
        a.appendChild(el("span", "skfb-res__title", p.title));
        if (p.priceCents) a.appendChild(el("span", "skfb-res__price", money(p.priceCents)));
        li.appendChild(a); ul.appendChild(li);
      });
      box.appendChild(ul);
    }
    if (d.biozidHinweis) box.appendChild(el("p", "skfb-res__legal", d.biozidHinweis));
    var acts = el("div", "skfb-res__acts");
    var plan = !!(d.group && d.sicher);
    var go = el("button", "skfb-btn skfb-btn--gold", plan ? T.plan : T.start); go.type = "button";
    go.addEventListener("click", function () { openBerater(plan ? d.group : null, via(source), go, d.sid); });
    var again = el("button", "skfb-btn skfb-btn--ghost", T.again); again.type = "button";
    again.addEventListener("click", function () { pick(function (f) { run(box, f, source); }); });
    acts.appendChild(go); acts.appendChild(again); box.appendChild(acts);
  }
  function renderError(box, msg, source) {
    box.textContent = ""; box.appendChild(el("p", "skfb-res__text", msg || T.err));
    var go = el("button", "skfb-btn skfb-btn--gold", T.start); go.type = "button";
    go.addEventListener("click", function () { openBerater(null, via(source), go); }); box.appendChild(go);
  }
  function busy(box) { box.hidden = false; box.setAttribute("aria-busy", "true"); box.textContent = ""; box.appendChild(el("p", "skfb-res__busy", T.busy)); }
  function run(box, file, source) {
    busy(box);
    var p = identify(file, source).then(function (res) {
      if (source === "search") last = { ok: true, res: res };
      return function (b) { render(b, res, source); };
    }, function (e) {
      var msg = e && e.message && !/^(read|img)$/.test(e.message) ? e.message : T.err;
      if (source === "search") last = { ok: false, msg: msg };
      return function (b) { renderError(b, msg, source); };
    });
    if (source === "search") pending = p;
    return p.then(function (draw) {
      /* Dropdown kann inzwischen neu aufgebaut worden sein → aktuelle Box im Such-Root nehmen */
      var target = box.isConnected ? box : (root && root.querySelector("[data-skfb-res]")) || box;
      if (source === "search") pending = null;
      target.hidden = false; draw(target); target.removeAttribute("aria-busy");
      var f = target.querySelector("a,button"); if (f && target.isConnected && target.offsetParent) f.focus();
    });
  }

  /* „Keine Ergebnisse“: Berater + Foto anbieten statt Sackgasse (03.11.2026) */
  function decorateEmpty(dropdown) {
    var empty = dropdown.querySelector(".sk-live-search__empty");
    if (!empty || dropdown.querySelector(".skfb-empty")) return;
    var box = el("div", "skfb-empty");
    box.appendChild(el("p", "skfb-empty__t", T.empty));
    var acts = el("div", "skfb-res__acts");
    var go = el("button", "skfb-btn skfb-btn--gold", T.start); go.type = "button";
    go.addEventListener("click", function () { openBerater(null, "suche", go); });
    var res = el("div", "skfb-res"); res.hidden = true; res.setAttribute("aria-live", "polite"); res.setAttribute("data-skfb-res", "");
    var up = el("button", "skfb-btn skfb-btn--ghost", T.photoShort); up.type = "button";
    up.addEventListener("click", function () { pick(function (f) { run(res, f, "search"); }); });
    acts.appendChild(go); acts.appendChild(up); box.appendChild(acts); box.appendChild(res);
    empty.parentNode.insertBefore(box, empty.nextSibling);
  }

  /* Upload-Block vor die „Beliebte Suchen“ im Dropdown setzen */
  function decorate(dropdown) {
    decorateEmpty(dropdown);
    var terms = dropdown.querySelector(".sk-live-search__terms");
    if (!terms || dropdown.querySelector(".skfb-panel")) return;
    var panel = el("div", "skfb-panel");
    var row = el("div", "skfb-row");
    var up = el("button", "skfb-upload"); up.type = "button"; up.appendChild(icon(IMG));
    var ut = el("span", "skfb-upload__t"); ut.appendChild(el("strong", null, T.photo)); ut.appendChild(el("small", null, T.photoSub)); up.appendChild(ut);
    row.appendChild(up);
    var res = el("div", "skfb-res"); res.hidden = true; res.setAttribute("aria-live", "polite"); res.setAttribute("data-skfb-res", "");
    up.addEventListener("click", function () { pick(function (f) { run(res, f, "search"); }); });
    if (window.matchMedia && matchMedia("(pointer: coarse)").matches) {
      var cam = el("button", "skfb-cam"); cam.type = "button"; cam.setAttribute("aria-label", T.camLabel);
      cam.appendChild(icon(CAM)); cam.appendChild(el("span", null, T.cam));
      cam.addEventListener("click", function () { pick(function (f) { run(res, f, "search"); }, true); });
      row.appendChild(cam);
    }
    panel.appendChild(row); panel.appendChild(res); panel.appendChild(el("p", "skfb-privacy", T.privacy));
    dropdown.insertBefore(panel, dropdown.firstChild);
    if (pending) busy(res);
    else if (last) { res.hidden = false; if (last.ok) render(res, last.res, "search"); else renderError(res, last.msg, "search"); }
  }

  function init() {
    root = document.querySelector("[data-sk-live-search]");
    if (!root) return;
    var btn = root.querySelector("[data-skfb-berater]");
    if (!boot()) { if (btn) btn.hidden = true; return; } /* Berater nur auf DE */
    if (btn) btn.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); headerBerater(btn); });
    var dd = root.querySelector("[data-sk-live-search-dropdown]");
    if (!dd) return;
    decorate(dd);
    new MutationObserver(function () { decorate(dd); }).observe(dd, { childList: true });
  }

  window.SkFotoBerater = {
    version: 3, openBerater: openBerater, render: render, run: run,
    /** Im Berater: Foto wählen und Ergebnis in `box` rendern. */
    pick: function (box, camera) { pick(function (f) { run(box, f, "berater"); }, camera); }
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
